import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Row, Col, Form, Button, Alert, Container } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import ManagerService from '../services/manager.service';

const SetPassword = () => {
  const { token } = useParams();
  const history = useHistory();
  const [formData, setFormData] = useState({
    password: '',
    password_confirm: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.password_confirm) {
      setError('As senhas não coincidem');
      return;
    }

    if (formData.password.length < 6) {
      setError('A senha deve ter no mínimo 6 caracteres');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await ManagerService.setPassword({
        token: token,
        password: formData.password,
        password_confirm: formData.password_confirm
      });

      setSuccess(true);
      
      // Redirecionar para login após 3 segundos
      setTimeout(() => {
        history.push('/login');
      }, 3000);

    } catch (err) {
      console.error('Error setting password:', err);
      const errorMsg = err.response?.data?.token?.[0] || 
                       err.response?.data?.password?.[0] ||
                       err.response?.data?.message || 
                       'Erro ao definir senha. Tente novamente.';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <section className="vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6} xl={5}>
              <Card border="light" className="shadow-sm">
                <Card.Body className="p-4 p-md-5">
                  <div className="text-center mb-4">
                    <div className="icon icon-shape icon-lg icon-shape-primary rounded-circle mb-3">
                      <FontAwesomeIcon icon={faLock} />
                    </div>
                    <h3>Defina sua Senha</h3>
                    <p className="text-muted">
                      Bem-vindo ao SGE Inovare! Crie uma senha para acessar o sistema.
                    </p>
                  </div>

                  {error && (
                    <Alert variant="danger" className="mb-3">
                      {error}
                    </Alert>
                  )}

                  {success ? (
                    <Alert variant="success">
                      <h5>Senha definida com sucesso!</h5>
                      <p className="mb-0">
                        Você será redirecionado para a página de login em instantes...
                      </p>
                    </Alert>
                  ) : (
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label>Nova Senha</Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          placeholder="Digite sua senha"
                          required
                          minLength={6}
                        />
                        <Form.Text className="text-muted">
                          Mínimo de 6 caracteres
                        </Form.Text>
                      </Form.Group>

                      <Form.Group className="mb-4">
                        <Form.Label>Confirmar Senha</Form.Label>
                        <Form.Control
                          type="password"
                          name="password_confirm"
                          value={formData.password_confirm}
                          onChange={handleInputChange}
                          placeholder="Digite sua senha novamente"
                          required
                          minLength={6}
                        />
                      </Form.Group>

                      <Button 
                        variant="primary" 
                        type="submit" 
                        className="w-100"
                        disabled={loading}
                      >
                        {loading ? 'Definindo senha...' : 'Definir Senha'}
                      </Button>
                    </Form>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default SetPassword;
